import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

import { stateMap } from '@digital-platform/rs-addresses/domain';
import { Facility } from '@digital-platform/rs-cms/domain';
import { CmsFacilitiesService } from '../cms-facilities/cms-facilities.service';

@Injectable({ providedIn: 'root' })
export class CmsFacilityResolver implements Resolve<Facility | undefined> {
  private stateReverseMap: Record<string, string> = {};
  constructor(private cmsFacilitiesService: CmsFacilitiesService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Facility | undefined> {
    this.stateReverseMap = this.createStateReverseMap(stateMap);

    const stateName = route.paramMap.get('state');
    const facilityName = route.paramMap.get('name');

    if (stateName && facilityName) {
      return this.cmsFacilitiesService.getFacilityByStateAndName(
        this.getStateCode(stateName),
        facilityName
      );
    }
    return of(undefined);
  }

  private createStateReverseMap(
    stateRecord: Record<string, string>
  ): Record<string, string> {
    const stateReverseMap: Record<string, string> = {};
    for (const [stateCode, stateName] of Object.entries(stateRecord)) {
      stateReverseMap[stateName] = stateCode;
    }
    return stateReverseMap;
  }

  private getStateCode(stateName: string): string {
    const parts: string[] = stateName.split('-');
    const stateParts = parts.map(
      (part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
    );
    const state = stateParts.join(' ');
    return this.stateReverseMap[state] || '';
  }
}
